import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FarmsIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.farmIcon}`}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 14 14'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11.0732 2.82422L14 5.75098L13.4561 6.29492L12.6709 5.50977V10.4434H13.2471V11.2129H0.75293V10.4434H1.3291V5.50977L0.543945 6.29492L0 5.75098L2.92676 2.82324L7 0.787109L11.0732 2.82422ZM3.38379 3.45508L2.09863 4.74023V10.4434H4.21289V6.59961H9.78809V10.4434H11.9014V4.74023L10.6162 3.45508L7 1.64648L3.38379 3.45508ZM5.69238 10.4434H8.30469L6.99805 9.39844L5.69238 10.4434ZM7.61426 8.90527L9.01855 10.0293V7.78223L7.61426 8.90527ZM4.98242 10.0264L6.38281 8.90527L4.98242 7.78516V10.0264ZM6.99805 8.41309L8.30566 7.36816H5.69141L6.99805 8.41309ZM8.44043 4.67773V5.44629H5.55762V4.67773H8.44043Z'
            fill='currentColor'
        />
    </svg>
);

export default FarmsIcon;
